import get from 'lodash/get'
import isString from 'lodash/isString'

function resolveCampaignId (campaign) {
  if (isString(campaign)) {
    return campaign
  }
  return get(campaign, 'friendlyId')
}

export function findRecordByCampaignId (records, campaignId) {
  if (!Array.isArray(records) || !campaignId) {
    return undefined
  }
  return records.find((record) => get(record, ['campaign', 'friendlyId']) === campaignId)
}

export function getCampaignFromRecords (records, props = {}) {
  const id = get(props, 'id')
  const record = findRecordByCampaignId(records, id)
  return get(record, 'campaign', {})
}

export function getSubjectFromRecords (records, props = {}) {
  const { campaign } = props
  const campaignId = resolveCampaignId(campaign)
  if (!campaignId) {
    return {}
  }
  return findRecordByCampaignId(records, campaignId) || {}
}

export function getVariationFromRecords (records, props = {}) {
  const subject = getSubjectFromRecords(records, props)
  return get(subject, 'variation', {})
}

export function campaignShouldRenderFromRecords (records, props = {}) {
  const { campaign } = props
  const campaignId = resolveCampaignId(campaign)
  const campaignObj = isString(campaign)
    ? getCampaignFromRecords(records, { id: campaignId })
    : campaign
  if (!['active', 'closed'].includes(get(campaignObj, 'status'))) {
    return false
  }
  const subject = getSubjectFromRecords(records, { campaign: campaignObj })
  const campaignVersion = get(campaignObj, 'version')
  if (!['active', 'closed'].includes(get(subject, 'status'))) {
    return false
  }
  if (get(subject, 'campaignVersion') !== campaignVersion) {
    return false
  }
  return get(subject, 'variation') != null
}

export function variationShouldRenderFromRecords (records, props = {}) {
  const { campaign, variation, subject } = props
  const campaignObj = isString(campaign)
    ? getCampaignFromRecords(records, { id: campaign })
    : campaign
  if (!['active', 'closed'].includes(get(campaignObj, 'status'))) {
    return false
  }
  const subjectRecord = subject || getSubjectFromRecords(records, { campaign: campaignObj })
  const subjectVariation = get(subjectRecord, 'variation', {})
  let variationObj = variation
  let variationFriendlyId = get(variationObj, 'friendlyId')
  if (variationObj == null || typeof variationObj === 'number') {
    variationFriendlyId = variationObj
    variationObj = subjectVariation
  } else if (typeof variationObj !== 'object' || Object.keys(variationObj).length === 0) {
    variationFriendlyId = variationObj
    variationObj = subjectVariation
  }
  const campaignVersion = get(campaignObj, 'version')
  const variationUuid = get(variationObj, 'uuid')
  if (get(subjectRecord, 'campaignVersion') !== campaignVersion) {
    return false
  }
  if (!['active', 'closed'].includes(get(subjectRecord, 'status'))) {
    return false
  }
  if (get(subjectVariation, 'uuid') !== variationUuid) {
    return false
  }
  if (get(subjectVariation, 'friendlyId') !== variationFriendlyId) {
    return false
  }
  return true
}
